import React, { Fragment, useState, useRef, useEffect } from "react"
import { connect } from "react-redux"
import { register } from "../../actions/authentication"
import { Container, Button, Box } from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"
import { useHistory } from "react-router-dom"
import Header from "components/Header"
import SplitBottomNav from "components/SplitBottomNav"
import EmployerCode from "./components/EmployerCode"
import RegisterForm from "./components/RegisterForm"
import AdditionalInfo from "./components/AdditionalInfo"
// import Loading from "components/Loading"
import { setIsLoading } from "actions/isLoading"
// import queryString from "query-string"
import { openSnackBar } from "actions/snack-bar"
import { getOrgFields } from "actions/organization"

const Register = ({ dispatch, classes }) => {
  let history = useHistory()
  const formRef = useRef()
  const [currentStep, setCurrentStep] = useState(0)
  // const [isLoading, setIsLoading] = useState(false)
  const [regData, setRegData] = useState({ additionalFields: {} })
  const [formSubmitted, setFormSubmitted] = useState(false)
  // const qParams = new queryString.parse(window.location.search)
  const urlParams = new URLSearchParams(window.location.search)
  const skipOrg = urlParams.get("skipOrg")
  const [haveFields, setHaveFields] = useState(true)

  const creatingOrg = skipOrg === "true"

  const handleRegistrationSubmit = () => {
    dispatch(setIsLoading(true))

    dispatch(
      register({
        ...regData,
        first_name: regData.firstName,
        last_name: regData.lastName,
        phone: regData.mobile
      })
    )
      .then(res => {
        if (creatingOrg) {
          return (window.location.href = `/signup?token=${res.token}&user=${res.id}`)
        }
        const host = window.location.host.split(".")
        const subdomain = res.user_orgs[0].subdomain
        dispatch(setIsLoading(false))
        // window.location = `http://${res.user_orgs[0].subdomain}.${host[1]}.${host[2]}/onboarding?token=${res.token}&user=${res.id}`

        if (host.length === 3) {
          window.location = `http://${subdomain}.${host[1]}.${host[2]}/onboarding?token=${res.token}&user=${res.id}`
        } else {
          window.location = `http://${subdomain}.${host[0]}.${host[1]}/onboarding?token=${res.token}&user=${res.id}`
        }

        return
      })
      .catch(err => {
        dispatch(setIsLoading(false))
        console.log(err)
      })
  }

  // Array of registration components
  let steps = []
  if (haveFields) {
    steps = [
      <EmployerCode
        updateRegData={updateRegData}
        formRef={formRef}
        regData={regData}
      />,
      <RegisterForm
        updateRegData={updateRegData}
        formRef={formRef}
        regData={regData}
      />,
      <AdditionalInfo
        updateRegData={updateRegData}
        formRef={formRef}
        regData={regData}
      />
    ]
  } else {
    steps = [
      <EmployerCode
        updateRegData={updateRegData}
        formRef={formRef}
        regData={regData}
      />,
      <RegisterForm
        updateRegData={updateRegData}
        formRef={formRef}
        regData={regData}
      />
    ]
  }

  useEffect(() => {
    if (regData.orgId) {
      dispatch(getOrgFields(regData.orgId))
        .then(res => {
          const fields = res.body.data
          setHaveFields(fields.length > 0)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }, [regData.orgId])

  // Runs handleRegistrationSubmit when form is submitted
  useEffect(() => {
    if (currentStep >= steps.length - 1 && formSubmitted) {
      handleRegistrationSubmit()
    } else if (
      formSubmitted &&
      currentStep + 1 >= steps.length - 1 &&
      creatingOrg
    ) {
      handleRegistrationSubmit(true)
    }
  }, [formSubmitted])

  // Updates register data and handles step increment
  function updateRegData(newData) {
    setRegData(prevData => ({ ...prevData, ...newData }))
    if (currentStep >= steps.length - 1) {
      setFormSubmitted(true)
    }

    if (currentStep < steps.length - 1 && !creatingOrg) {
      setCurrentStep(currentStep + 1)
    } else {
      setFormSubmitted(true)
    }
  }

  const handleSignUp = () => {
    if (!creatingOrg) {
      history.push("/login")
    } else {
      history.push("/login?skipOrg=true")
    }
  }

  const handleNext = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  const handleBack = () => {
    setCurrentStep(currentStep - 1)
  }

  useEffect(() => {
    if (creatingOrg) {
      setCurrentStep(1)
      dispatch(
        openSnackBar({
          message: "Please register before creating an organization"
        })
      )
    }
  }, [creatingOrg])

  const showSignIn = currentStep === 0 || creatingOrg
  const isDesktop = window.innerWidth > 800
  return (
    <Fragment>
      <Header />
      <Container
        style={{
          maxWidth: isDesktop ? "550px" : "none",
          paddingTop: "40px",
          paddingRight: "40px",
          paddingLeft: "40px"
        }}
      >
        {steps[currentStep]}
        {window.innerWidth >= 1280 ? (
          <Box style={{ marginTop: currentStep === 1 ? "30px" : "300px" }}>
            <Button
              className={classes.backButton}
              variant="contained"
              onClick={showSignIn ? handleSignUp : handleBack}
            >
              <Box display="flex" flexDirection="column">
                <span className={classes.haveAnAccountText}>
                  {showSignIn ? "Have an account? " : ""}
                </span>
                <span>{showSignIn ? "Sign In" : "Back"}</span>
              </Box>
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.nextButton}
              onClick={handleNext}
            >
              {currentStep < steps.length - 1 && !creatingOrg
                ? "Next"
                : "Submit"}
            </Button>
          </Box>
        ) : null}
      </Container>
      {window.innerWidth < 1280 ? (
        <SplitBottomNav>
          <Button
            color="primary"
            onClick={showSignIn ? handleSignUp : handleBack}
          >
            {showSignIn ? <span>Have an account</span> : ""}
            {showSignIn ? "Sign In" : "Back"}
          </Button>
          <Button onClick={handleNext}>
            {currentStep < steps.length - 1 && !creatingOrg ? "Next" : "Submit"}
          </Button>
        </SplitBottomNav>
      ) : null}

      {/* {isLoading && <Loading />} */}
    </Fragment>
  )
}

const mapStateToProps = state => {
  return {
    profile: state.profile,
    isLoading: state.isLoading.loading
  }
}

const connector = connect(mapStateToProps)

export default withStyles(styles)(connector(Register))



// WEBPACK FOOTER //
// ./src/pages/Register/index.js